import {NgModule} from "@angular/core";
import {KzNumberPipe} from "./kz-number.pipe";

@NgModule({
  imports: [KzNumberPipe],
  exports: [KzNumberPipe],
  providers: [KzNumberPipe]
})
export class AppPipesModule {
}
